import React from "react";
import { Box } from "@origin-digital/ods-core";
import { ContentSkeleton } from "../../../../components/Article";
import { BreadCrumbs } from "../../../../components/Breadcrumb";
import { ArticleBody } from "../../../../components/Articles";

interface ContentSectionProps {
  isLoading?: boolean;
  breadcrumbs: { label: string; url: string }[];
  body: string;
  title: string;
  isFdvArticle?: boolean;
}

export const ContentSection: React.FC<ContentSectionProps> = (props) => {
  const { isLoading, breadcrumbs, body, title, isFdvArticle } = props;

  return (
    <Box
      gap="none"
      margin="none"
      paddingBottom="medium"
      marginX={{ xs: "medium", lg: "none" }}
    >
      <BreadCrumbs
        breadcrumbs={breadcrumbs}
        isLoading={isLoading}
        noOfSkeletons={3}
      />
      {isLoading ? (
        <ContentSkeleton />
      ) : (
        <ArticleBody body={body} title={title} isFdvArticle={isFdvArticle} />
      )}
    </Box>
  );
};
